import {
  IconButton,
  SingleNeutralActionsUpDownIcon,
  Tooltip
} from '@libs/ui/ds'
import { usePlanningTranslation } from '@libs/utils/translations'
import { sortEmployeeModalDef } from '@spa/scenes/Plannings/Modals/SortEmployeesModal/SortEmployeesModal'
import React from 'react'

const SortEmployeesContainer = ({ teamId }) => {
  const { t } = usePlanningTranslation()
  const { open } = sortEmployeeModalDef.useDispatchModal()

  return (
    <Tooltip label={t('weekly.header.sortEmployees')}>
      <IconButton
        variant='tertiary'
        intent='neutral-dark'
        size='s'
        icon={<SingleNeutralActionsUpDownIcon />}
        onClick={() => open({ teamId })}
      />
    </Tooltip>
  )
}
export default SortEmployeesContainer
